import { render } from "./suppliers-modal.vue?vue&type=template&id=13bef51e"
import script from "./suppliers-modal.vue?vue&type=script&lang=js"
export * from "./suppliers-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__